module.exports = __webpack_public_path__ + "img/seaPalace-2.8a3edb8f.jpg";